import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import { css } from "styled-components";

Object.assign(userListUsersTableStyles, {
    ...userListUsersTableStyles,
    dataTable: {
        css: css`
            border: 1px solid #ddd;
            th,
            td {
                border-right: 1px solid #ddd;
            }
        `,
    },
    usernameHeader: {
        css: css`
            border-bottom: 2px solid #d0d0d0;
            button {
                :hover {
                    span {
                        color: #222;
                        text-decoration: none;
                    }
                }
            }
            span[class^="TypographyStyle"] {
                font-size: 14px;
                color: #06c;
            }
        `,
    },
    nameHeader: {
        css: css`
            border-bottom: 2px solid #d0d0d0;
            button {
                :hover {
                    span {
                        color: #222;
                        text-decoration: none;
                    }
                }
            }
            span[class^="TypographyStyle"] {
                font-size: 14px;
                color: #06c;
            }
        `,
    },
    roleHeader: {
        css: css`
            border-bottom: 2px solid #d0d0d0;
            button {
                :hover {
                    span {
                        color: #222;
                        text-decoration: none;
                    }
                }
            }
            span[class^="TypographyStyle"] {
                font-size: 14px;
                color: #06c;
            }
        `,
    },
    statusHeader: {
        css: css`
            border-bottom: 2px solid #d0d0d0;
            span[class^="TypographyStyle"] {
                font-size: 14px;
            }
        `,
    },
    lastSignInHeader: {
        css: css`
            border-bottom: 2px solid #d0d0d0;
            span[class^="TypographyStyle"] {
                font-size: 14px;
            }
        `,
    },
    dataTableBody: {
        css: css`
            tr,
            td,
            span[class^="TypographyStyle"] {
                font-size: 14px;
            }
        `,
    },
});
